import type { LocalDivisionLookup } from '../types/local-division-lookup.type';
import { GuidNameCodeModel } from './guid-name-code.model';

export class LocalDivisionLookupModel
  extends GuidNameCodeModel
  implements LocalDivisionLookup
{
  readonly displayedName: string | null;
  readonly productGroups: GuidNameCodeModel[] | null = null;

  constructor(data: LocalDivisionLookup) {
    super(data);

    this.displayedName = data.displayedName;

    if (data.productGroups) {
      this.productGroups = data.productGroups.map(
        (item) => new GuidNameCodeModel(item),
      );
    }
  }
}
